export class PolicyModel {
  id!: number;
  name!: string;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;

  constructor(data?: Partial<PolicyModel>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}